import Validation from 'utils/validation.utils';

export const initialState = (state = {}) => {
  const {
    name = {
      value: '',
      disabled: false
    },
    code = {
      value: '',
      disabled: false
    },
    interest = {
      value: '',
      disabled: false
    },
    terms = {
      value: '',
      disabled: false
    },
    year = {
      value: '',
      disabled: false
    },
    type = {
      value: '',
      disabled: false
    }
  } = state;
  return {
    name: {
      name: 'name',
      validations: [Validation.required({ noMessage: true })],
      label: 'Name',
      required: true,
      ...name
    },
    code: {
      name: 'code',
      validations: [Validation.required({ noMessage: true })],
      maxLength: 5,
      label: 'Code',
      required: true,
      ...code
    },
    interest: {
      name: 'interest',
      validations: [Validation.required({ noMessage: true })],
      label: 'Interest',
      placeholder: `0.00`,
      required: false,
      ...interest
    },
    terms: {
      name: 'terms',
      label: 'Terms',
      placeholder: `0`,
      required: false,
      ...terms
    },
    year: {
      name: 'year',
      label: 'Year',
      required: false,
      ...year
    },
    type: {
      name: 'type',
      label: 'Type',
      required: false,
      ...type
    }
  };
};
